import React from 'react';
import { FadeIn } from './FadeIn';
import { Heart } from 'lucide-react';
export function Hook() {
  return <section className="py-16 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-125">
      <div className="max-w-3xl mx-auto text-center" data-id="element-126">
        <FadeIn data-id="element-127">
          <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-8 shadow-sm" data-id="element-128">
            <Heart className="w-8 h-8 text-peach" data-id="element-129" />
          </div>
          <p className="text-xl md:text-2xl font-heading text-darkText leading-relaxed mb-8" data-id="element-130">
            ¿Te imaginas recibir notificaciones de venta en tu celular mientras
            juegas con tus hijos o preparas la cena?
          </p>
          <p className="text-lg text-lightText mb-8" data-id="element-131">
            El mercado de decoración infantil en Estados Unidos es una mina de
            oro de{' '}
            <strong className="text-darkText font-bold" data-id="element-132">
              $4 billones de dólares
            </strong>
            , y ahora la Inteligencia Artificial te ha entregado la llave para
            entrar en él.
          </p>
          <p className="text-lg text-lightText" data-id="element-133">
            Ya no necesitas ser una artista profesional ni dominar programas
            complicados para generar ingresos en dólares. La tecnología ha
            eliminado las barreras; solo necesitas el mapa correcto para
            empezar.
          </p>
        </FadeIn>
      </div>
    </section>;
}